import { Link } from "react-router-dom";
import json from "./encore.json";
import { Project } from "../../components/project";
import { IoIosArrowForward } from "react-icons/io";

export const EncoreFans = () => {
  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} />
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">Link to the project</div>
      <div className="flex text-secondary justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <div>
          Please
          <Link to={"/contact"} className="text-xl italic text-secondary mx-1">
            contact me
          </Link>
          for further details
        </div>
      </div>
    </div>
  );
};
